import type { PaymentMethodType } from '../../entities/enums';
import type { HirerPaymentResult } from '../../types';
import {
  PaymentActionRequiredError,
  PaymentDefaultError,
} from '../Errors/customErrors';

export const payWithCallback = async (
  executePay: () => Promise<HirerPaymentResult | undefined>,
  paymentMethod: PaymentMethodType,
): Promise<HirerPaymentResult | undefined> => {
  const result = await executePay();

  // handle linting possiblility of undefined in handlePayAndPostButtonClick function, need to improve later
  if (!result || result.status === 'requires_payment_method') {
    throw new PaymentDefaultError(`payWithCallback with result: ${result}`);
  }

  if (result.status === 'requires_action') {
    throw new PaymentActionRequiredError(
      'status is requires_action',
      paymentMethod,
    );
  }
  if (result.status !== 'succeeded') {
    throw new Error(
      `Payment failed with payment method: ${paymentMethod}, result: ${JSON.stringify(
        result,
      )}`,
    );
  }

  return { paymentMethod, ...result };
};
